import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import {SsoApi} from 'Users/api/api';
import {ValidSSOAccount} from 'Users/models/SSOAccount';
import {SSOEntityId} from 'Users/models/SSOEntityId';

const ssoApi = new SsoApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const deleteAccount = (encryptedIdentifier: string, userId: string, username: string) =>
  ssoApi.ssoSsoRemove(userId, '1', username, {params: {encryptedIdentifier}, ...getAxiosConfig()}).then(handleResponse);
const getAccount = (encryptedIdentifier: string, userId: string, username: string) =>
  ssoApi
    .ssoSsoAccount(userId, '1', username, {params: {encryptedIdentifier}, ...getAxiosConfig()})
    .then(handleResponse);
const getAccounts = (encryptedIdentifier: string, userId: string) =>
  ssoApi.ssoSsoAccounts(userId, '1', {params: {encryptedIdentifier}, ...getAxiosConfig()}).then(handleResponse);
const saveSSOAccount = (encryptedIdentifier: string, userId: string, account: ValidSSOAccount, isExisting: boolean) =>
  isExisting
    ? ssoApi
        .ssoSsoUserUpdate(
          userId,
          '1',
          {
            password: account.password.value.value,
            username: account.username.value.value,
          },
          {params: {encryptedIdentifier}, ...getAxiosConfig()}
        )
        .then(handleResponse)
    : ssoApi
        .ssoSsoInsert(
          userId,
          '1',
          {
            isPrimary: account.isPrimary,
            password: account.password.value.value,
            username: account.username.value.value,
          },
          {params: {encryptedIdentifier}, ...getAxiosConfig()}
        )
        .then(handleResponse);

const getSSOUrl = (encryptedIdentifier: string, userId: string, username: string, ssoEntityId: SSOEntityId) =>
  ssoApi
    .ssoSsoRequest(userId, ssoEntityId, '1', username, {
      params: {encryptedIdentifier},
      ...getAxiosConfig(),
    })
    .then(handleResponse);

const getLegacyForm = (userId: string, isNewYork: boolean, isInteractive: boolean, encryptedIdentifier: string) =>
  ssoApi
    .ssoSsoLegacyForms(userId, '1', isNewYork, isInteractive, {params: {encryptedIdentifier}, ...getAxiosConfig()})
    .then(handleResponse);

const getLegacyBulletin = (userId: string, isNewYork: boolean, encryptedIdentifier: string) =>
  ssoApi
    .ssoSsoLegacyBulletins(userId, '1', isNewYork, {params: {encryptedIdentifier}, ...getAxiosConfig()})
    .then(handleResponse);

export default {
  deleteAccount,
  getAccount,
  getAccounts,
  saveSSOAccount,
  getSSOUrl,
  getLegacyForm,
  getLegacyBulletin,
};
